  <template>
    <div class="custom-actions">
      <a class="btn btn-sm" v-bind:href="'/' + modeltype + '/profile/' + rowData.id"><i class="fa fa-search-plus"></i></a>
    </div>
  </template>

  <script>
  export default {
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      },
      modeltype: {
        type: String
      }
    },
    methods: {
      itemAction (action, data, index) {
        console.log('custom-actions: ' + action, data.name, index)
      },
      viewUrl () {
        return
      }
    }
  }
  </script>

  <style>
    .custom-actions button.ui.button {
      padding: 8px 8px;
    }
    .custom-actions button.ui.button > i.icon {
      margin: auto !important;
    }
  </style>


// WEBPACK FOOTER //
// resources/assets/js/components/Players/CustomActions.vue